import { CALL_API } from '../../../../common/middleware/api';

export const STRIPE_CARD_UPDATE_START = 'STRIPE_CARD_UPDATE_START';
export const STRIPE_CARD_UPDATE_FAILED = 'STRIPE_CARD_UPDATE_FAILED';

export const STRIPE_SETUP_INTENT_REQUEST = 'STRIPE_SETUP_INTENT_REQUEST';
export const STRIPE_SETUP_INTENT_SUCCESS = 'STRIPE_SETUP_INTENT_SUCCESS';

export const submitStripePaymentForm = (paymentMethod) => (dispatch, getState) => {
	const { stripeSubmitHandle } = getState().paymentProcessors[paymentMethod.name];
	return new Promise((resolve, reject) => {
		stripeSubmitHandle()
			.then(result => {
				const submitError = result.error;
				if (submitError) {
					reject(submitError.message);
				} else {
					resolve();
				}
			});
	});
};

export const confirmStripePayment = (paymentMethod, clientAuthorizationToken, returnUrl) => (dispatch, getState) => {
	const { stripePaymentHandle } = getState().paymentProcessors[paymentMethod.name];
	return new Promise((resolve, reject) => {
		stripePaymentHandle(clientAuthorizationToken, returnUrl)
			.then(result => {
				if (result.error) {
					reject(result.error);
				} else {
					resolve(result.paymentIntent || result.setupIntent);
				}
			});
	});
};

export const updatePaymentOption = (stripe, elements, payment) => (dispatch) => {
	if (payment && payment.paymentMethod && payment.paymentMethod.name === 'Stripe') {
		dispatch({ type: STRIPE_CARD_UPDATE_START, payload: { paymentId: payment.id } });
		// trigger form validation and wallet collection
		elements.submit().then(submitResult => {
			const submitError = submitResult.error;
			if (submitError) {
				dispatch({ type: STRIPE_CARD_UPDATE_FAILED, message: submitError.message, paymentId: payment.id });
			} else {
				// request client secret to confirm the setup intent
				dispatch({
					[CALL_API]: {
						types: [STRIPE_SETUP_INTENT_REQUEST, STRIPE_SETUP_INTENT_SUCCESS, STRIPE_CARD_UPDATE_FAILED],
						endpoint: 'api/paymentMethods/stripe/cardUpdate',
						method: 'POST',
						request: { paymentId: payment.id },
						errorPayload: { paymentId: payment.id },
						onSuccess: (response) => {
							// confirm Stripe setup intent with a client secret
							if (response.clientSecret) {
								stripe.confirmSetup({
									elements,
									clientSecret: response.clientSecret,
									confirmParams: {
										return_url: response.returnUrl
									},
									redirect: 'if_required'
								}).then(confirmResult => {
									const confirmError = confirmResult.error;
									if (confirmError) {
										dispatch({ type: STRIPE_CARD_UPDATE_FAILED, message: confirmError.message, paymentId: payment.id });
									} else {
										window.location = response.returnUrl;	// reload current page with cardUpdated query param
									}
								}, error => dispatch({ type: STRIPE_CARD_UPDATE_FAILED, message: error, paymentId: payment.id }));
							}
						}
					}
				});


			}
		}, error => dispatch({ type: STRIPE_CARD_UPDATE_FAILED, message: error, paymentId: payment.id }));
	}
};